import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons'
import {
  Button,
  DatePicker,
  Empty,
  Form,
  Input,
  Select,
  Space,
  Tooltip
} from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useCallback, useEffect, useState, useMemo } from 'react'
import {
  departmentCreate,
  departmentDelete,
  departmentDetail,
  departmentSearch,
  departmentUpdate,
  pakagesSearch
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import styles from './styles.module.scss'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import { hasPermission, removeVietnameseTones } from '../../config-func'
import Loading from '../Loading';
const { Option } = Select

export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
const layout = {
  // labelCol: {
  //   span: 11
  // },
  wrapperCol: {
    span: 24
  }
}
const { TextArea } = Input

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const DepartmentManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pageSize, setPageSize] = useState(10) // Kích thước trang mặc định
  const [page, setCurrentPage] = useState(1) // Trang hiện tại
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listDepartment, setListDepartment] = useState([])
  const [listPakages, setListPakages] = useState([])
  const [loading, setLoading] = useState(false)

  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10, // Số bản ghi mỗi trang
    reset: 0
  })

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Sàn',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (_, record) => {
        return (
          <div style={{maxWidth: 400,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              overflowWrap: 'break-word'}}>
            {record.name}
          </div>
        )
      }
    },
    {
      title: 'Quản lý	',
      dataIndex: 'manage',
      key: 'manage',
      width: 150,
      render: (_, record) => {
        // Kiểm tra record.users có dữ liệu không
        if (!record.users || record.users.length === 0) {
          return '' // Hiển thị "-" nếu không có user
        }

        // Ghép danh sách tên user thành chuỗi, đảm bảo là string hợp lệ
        // const names = record.users.map((item) => item.name).join(', ');

        // return <span>{names}</span>; // Trả về JSX hợp lệ
        return (
          <div>
            {record.users.map((user) => (
              <div key={user.id}>{user.name}</div> // Hiển thị mỗi user trên 1 dòng
            ))}
          </div>
        )
      }
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone',
        key: 'phone',
      width: 150,
      render: (_, record) => {
        // Kiểm tra record.users có dữ liệu không
        if (!record.users || record.users.length === 0) {
          return '' // Hiển thị "-" nếu không có user
        }

        // Ghép danh sách tên user thành chuỗi, đảm bảo là string hợp lệ
        // const phones = record.users.map((item) => item.phone).join(', ');

        // return <span>{phones}</span>; // Trả về JSX hợp lệ
        return (
          <div>
            {record.users.map((user) => (
              <div key={user.id}>{user.phone}</div> // Hiển thị mỗi user trên 1 dòng
            ))}
          </div>
        )
      }
    },
    {
      title: 'Gói thuê',
      dataIndex: 'rental_package',
      key: 'rental_package',
      width: 150,
      render: (_, record) => {
        const label =
          (listPakages &&
            listPakages?.list?.find(
              (item) => item.order == record.rental_package
            )?.name) ||
          ''
        return label
      }
    },
    { title: 'Số nhân viên', dataIndex: 'user_count', key: 'user_count',
      width: 120,
     },
    { title: 'Số tin đăng', dataIndex: 'post_count', key: 'post_count',width: 120, },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'expire_date',
      key: 'expire_date',
      width: 150,
      render: (date) => dayjs(date).format('DD/MM/YYYY')
    },
    {
      title: 'Ngày tham gia',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (date) => dayjs(date).format('DD/MM/YYYY')
    },
    {
      title: 'Sàn liên kết',
      dataIndex: 'department_links',
      key: 'department_links',
      width: 170,
      render: (_, record) => {
        const departmentNames = record.department_links
          .map((item) => item.department_info?.name)
          .join(', ')
        return <span>{departmentNames || ''}</span>
      }
    },
    {
      title: 'Thông tin chi tiết',
      dataIndex: 'description',
      key: 'description',
      width: 150,
    },
    {
      title: 'Thao tác',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P41.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailDepartment(record.id)
                    getDepartmentFull()
                  }}
                />
              </Tooltip>
            )}
            {/* <Tooltip title="Chỉnh sửa">
              <EditOutlined
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailDepartment(record.id)
                }}
                style={{ fontSize: '16px', color: '#08c', cursor: 'pointer' }}
              />
            </Tooltip> */}
            {record.status !== 'inactive' &&
              hasPermission('P41.3', permissions) && (
                // <DeleteOutlined
                //   onClick={() =>
                //     showConfirm({
                //       title: 'Xoá Sàn',
                //       content: (
                //         <div>
                //           Bạn có chắc chắn muốn xoá sàn
                //           <b> {record.name}</b> không?
                //         </div>
                //       ),
                //       onOk: () => deleteDepartment(record)
                //     })
                //   }
                //   style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                // />
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá Sàn',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá sàn
                            <b> {record.name}</b> không?
                          </div>
                        ),
                        onOk: () => deleteDepartment(record)
                      })
                    }
                  />
                </Tooltip>
              )}
            {/* <Button type="primary">Chi tiết</Button>
            <Button danger>Xóa</Button> */}
          </Space>
        )
      }
    }
  ]

  const [listDepartmentFull, setListDepartmentFull] = useState([])
  const getDepartmentFull = async (values) => {
    // const d_id = localStorage.getItem('department_id')
    setLoading(true)
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name: name.trim(), type, page, pageSize }
      const res = await departmentSearch(body)
      const filteredData = res.data?.list?.filter(item => item.name !== form.getFieldValue('name'));
      setListDepartmentFull(filteredData)

    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại')
    } finally {
      setLoading(false)
    }
  }

  const getDepartmentAll = async (values) => {
    // const d_id = localStorage.getItem('department_id')
    setLoading(true)
    let { name = '', type = '', page = 1, pageSize = pagination.pageSize || 10 } = values || {}
    try {
      const body = { name: name.trim(), type, page, pageSize }
      const res = await departmentSearch(body)
      
      setListDepartment(res.data)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại')
    } finally {
      setLoading(false)
    }
  }
  const getListPakages = async () => {
    try {
      const res = await pakagesSearch()
      setListPakages(res.data)
    } catch (err) {}
  }

  useEffect(() => {
    getListPakages()
    // getDepartmentAll()
  }, [])

  const handleSearch = debounce((values) => {
    console.log('Tìm kiếm với:', values)
  }, 300)

  const debouncedFormChange = useCallback(
    debounce(() => {
      const allValues = formSearch.getFieldsValue() // Lấy tất cả giá trị từ form
      getDepartmentAll({
        ...allValues, // Truyền toàn bộ giá trị form
        page: pagination.current, // Giữ nguyên trang hiện tại
        pageSize: pagination.pageSize // Giữ nguyên số lượng item mỗi trang
      })
    }, 300),
    [formSearch, pagination.current, pagination.pageSize]
  )

  // Form change handler with debounce
  const handleFormChange = (changedValues, allValues) => {
    debouncedFormChange(changedValues, allValues)
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      const values = await form.validateFields()

      const body = {
        ...values,
        departments_id: values.department_links
        // expire_date: dayjs(values.expire_date).format('DD/MM/YYYY')
      }

      const apiCall =
        mode === ACTION_MODE.ADD
          ? departmentCreate(body)
          : departmentUpdate(body, values.id)

      await apiCall // Chờ API hoàn tất

      // Reset form và đóng modal
      setIsModalOpen(false)
      form.resetFields()

      // Gọi lại danh sách với dữ liệu tìm kiếm hiện tại
      getDepartmentAll({
        name: formSearch.getFieldValue('name'),
        type: formSearch.getFieldValue('type')
      })

      // Hiển thị thông báo thành công
      openNotification(
        'success',
        mode === ACTION_MODE.ADD
          ? 'Thêm mới sàn thành công'
          : 'Cập nhật sàn thành công'
      )
    } catch (err) {
      console.error('Error:', err)

      // Lấy lỗi từ response API
      const errorMessages =
        get(err, 'response.data.data', [])
          ?.map((error) => error.message)
          .join('\n') || get(err, 'response.data.message', 'Đã có lỗi xảy ra')

      openNotification('error', errorMessages)
    } finally {
      setLoading(false)
    }
  }
  const deleteDepartment = async (item) => {
    setLoading(true)
    try {
      // Validate các trường trong form
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      // Lọc ra các key có giá trị true và đưa vào mảng

      const res = await departmentDelete(item.id)

      getDepartmentAll()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const getDetailDepartment = async (id) => {
    setLoading(true)
    try {
      const res = await departmentDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        const departmentLinks = values.department_links?.map(
          (item) => item.department_link
        )

        form.setFieldsValue({
          ...values,
          expire_date: values.expire_date
            ? dayjs(values.expire_date)
            : values.expire_date,
          department_links: departmentLinks
          // tradingDate: dayjs(values.tradingDate, 'DD/MM/YYYY'),
        })
      } else {
        console.error('No data found or invalid response')
      }
    } catch (err) {
      console.error('Error fetching roles:', err)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()

      getDepartmentAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize, pagination.reset])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }
  const handleReset = debounce( () => {
    formSearch.resetFields()
    // getUserAll()
    setPagination((prev) => ({
      current: 1, // Nếu đổi pageSize thì reset current
      pageSize: 10,
      reset: uuidv4()
    }))
  }, 300)
  
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <Form
          form={formSearch}
          // onValuesChange={handleFormChange}
          layout="vertical"
          onFinish={debouncedFormChange}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            {/* Ô tìm kiếm */}
            <Form.Item
              label="Tên sàn"
              name="name"
              className={styles.formItem}
              labelCol={{ span: 8 }}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập tên sàn"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'name',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>
            {/* Dropdown Loại (rộng hơn) */}
            <Form.Item
              label="Gói thuê"
              name="type"
              className={styles.formItem}
              labelCol={{ span: 8 }}
            >
              <Select
                defaultValue="Tất cả"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                <Option value="">Tất cả</Option>
                {listPakages?.list?.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.id}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <div
              className={styles.formItem}
              style={{ textAlign: 'right', marginTop: 6 }}
            >
              <Button onClick={handleReset}>Đặt lại</Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
              >
                Tìm kiếm
              </Button>
            </div>
            {/* Dropdown Trạng thái (rộng hơn) */}
            {/* <Col span={6}>
              <Form.Item label="Trạng thái" name="status">
                <Select defaultValue="Tất cả">
                  <Option value="all">Tất cả</Option>
                  <Option value="active">Hoạt động</Option>
                  <Option value="inactive">Ngừng hoạt động</Option>
                </Select>
              </Form.Item>
            </Col> */}
          </div>
        </Form>
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Danh sách sàn</h2> */}
          {hasPermission('P41', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
                getDepartmentFull()
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={listDepartment?.list}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: listDepartment.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
            // onShowSizeChange: (current, size) => {
            //   setPageSize(size) // Cập nhật lại kích thước trang
            //   // setCurrentPage(1) // Reset lại trang khi thay đổi kích thước trang
            // },

            // onChange: (page) => {
            //   setCurrentPage(page) // Cập nhật trang khi người dùng thay đổi trang
            //   getDepartmentAll({ page: page })
            // }
          }}
          rowKey={(record, index) => index}
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={mode == ACTION_MODE.UPDATE ? 'Chỉnh sửa sàn' : 'Thêm mới sàn'}
        visible={isModalOpen}
        centered
        // width={1200}
        className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <Form
          requiredMark={customizeRequiredMark}
          labelAlign="left"
          form={form}
          layout="vertical"
          style={{
            // maxHeight: '80vh',
            overflow: 'auto',
            overflowX: 'hidden',
            padding: '0px 10px'
          }}
          {...layout}
        >
          <Form.Item name="id" label="" style={{ display: 'none' }}>
            <Input></Input>
          </Form.Item>
          <Form.Item
            label="Tên sàn"
            name="name"
            rules={[
              {
                message: 'Vui lòng nhập tên sàn',
                required: true
              }
            ]}
          >
            <Input
              placeholder="Nhập tên sàn"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>

          <Form.Item
            label="Gói thuê"
            name="rental_package"
            
            rules={[
              {
                message: 'Vui lòng chọn gói thuê',
                required: true
              }
            ]}
          >
            <Select
                // defaultValue=""
                placeholder="Chọn gói thuê"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase()
                  const optionValue = removeVietnameseTones(
                    option?.children || ''
                  ).toLowerCase()
                  return optionValue.includes(inputValue)
                }}
              >
                {listPakages?.list?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
          </Form.Item>

          <Form.Item
            label="Ngày hết hạn"
            name="expire_date"
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn loại vai trò'
              }
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              placeholder="Chọn ngày hết hạn"
              disabledDate={(current) =>
                current && current < dayjs().startOf('day')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item label="Liên kết sàn" name="department_links">
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Chọn sàn liên kết"
              allowClear
              showSearch
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(
                  option?.children || ''
                ).toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {listDepartmentFull?.map((item, idx) => {
                return (
                  <Option key={idx} value={item.id}>
                    {item.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Thông tin chi tiết" name="description">
            <TextArea rows={4} maxLength={1000} />
          </Form.Item>
        </Form>
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default DepartmentManagement
